import { Divider } from '@mui/material'
import { FC } from 'react'

export const SidebarDivider: FC = () => <Divider sx={{ m: '8px 16px' }} />
